<template>
  <b-sidebar id="add-new-user-sidebar" :visible="isAddNewDriverSidebarActive" bg-variant="white"
    sidebar-class="sidebar-lg" shadow backdrop no-header right @hidden="resetDriverData"
    @change="(val) => $emit('update:is-add-new-driver-sidebar-active', val)">

    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Add New Driver') }}
        </h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />

      </div>

      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>

      <!-- BODY -->
      <!-- Form -->
      <b-form class="p-2" @submit.prevent="onSubmit">

        <!-- Name -->

        <b-form-group :label="$t('Name')" label-for="name">
          <b-form-input id="name" v-model="driverData.name" autofocus :state="errors && !('name' in errors)" trim
            autocomplete="off" placeholder="" />
          <!-- <b-form-invalid-feedback v-if="errors && ('fill_areas' in errors)"
                                 :state="errors && ('fill_areas' in errors) ? false : null">
          {{ errors.fill_areas[0]  }}
        </b-form-invalid-feedback> -->


          <b-form-invalid-feedback v-if="errors && ('name' in errors)">
            {{ errors ? errors.name[0] : null }}
          </b-form-invalid-feedback>

        </b-form-group>


        <!-- uniqueid -->
        <b-form-group :label="$t('driver uniqueid')" label-for="uniqueid">
          <b-form-input id="uniqueid" autocomplete="off" v-model="driverData.uniqueId"
            :state="errors && !('uniqueId' in errors)" trim />

          <b-form-invalid-feedback v-if="errors && ('uniqueId' in errors)">
            {{ errors ? errors.uniqueId[0] : null }}
          </b-form-invalid-feedback>
        </b-form-group>



        <!-- uniqueid -->
        <b-form-group :label="$t('mobile number')" label-for="mobileNumber">
          <b-form-input id="mobileNumber" autocomplete="off" v-model="driverData.mobileNumber"
            :state="errors && !('mobileNumber' in errors)" trim />

          <b-form-invalid-feedback v-if="errors && ('mobileNumber' in errors)">
            {{ errors ? errors.mobileNumber[0] : null }}
          </b-form-invalid-feedback>
        </b-form-group>



        <!-- Owner -->
        <b-form-group :label="$t('Owner')" label-for="owner" :state="null">
          <v-select v-model="driverData.owner_id" label="name"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :options="ownersOptions" :reduce="val => val.id"
            :clearable="false" input-id="owner" :state="errors && !('mobileNumber' in errors)" />
          <b-form-invalid-feedback v-if="errors && ('owner_id' in errors)">
            {{ errors ? errors.owner_id[0] : null }}
          </b-form-invalid-feedback>

        </b-form-group>




        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
            {{ $t('Save') }}
          </b-button>
          <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" variant="outline-secondary"
            @click="resetDriverData">
            {{ $t('Reset') }}
          </b-button>
        </div>
      </b-form>

    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    OrbitSpinner,

    flatPickr,

  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewDriverSidebarActive',
    event: 'update:is-add-new-driver-sidebar-active',
  },
  props: {
    isAddNewDriverSidebarActive: {
      type: Boolean,
      required: true,
    },

    ownersOptions: {
      type: Array,
      required: true,
    },


  },
  setup(props, { emit }) {

    const blankDriverData = {
      name: '',
      uniqueid: '',
      ownerid: null
    }


    const errors = ref(null)

    const requestStatus = ref(false)

    const driverData = ref(JSON.parse(JSON.stringify(blankDriverData)))
    const resetDriverData = () => {
      driverData.value = JSON.parse(JSON.stringify(blankDriverData))
    }

    const onSubmit = () => {

      requestStatus.value = true
      //console.log('data added is ', driverData.value)
      store.dispatch('app_driver/addDriver', driverData.value)
        .then(() => {
          requestStatus.value = false
          emit('refetch-data')
          emit('update:is-add-new-driver-sidebar-active', false)
        }).catch(res => {

          requestStatus.value = false
          if (res.response.status === 422) {

            errors.value = res.response.data.errors
          }


        }
        )
    }



    return {
      driverData,
      onSubmit,
      resetDriverData,
      requestStatus,
      errors
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
